<div id="contact" class="form-step-modal modal fade" tabindex=-1 role="dialog">
  <div class="modal-dialog custum-drop-modal modal-dialog-centered modal-lg" role="document">
    <div class="modal-content form-step-modal__content">

      <div class="modal-body form-contact-modal__body">

        <section id="contact-content">
          <div class="flexible flex-just-center">
            <div class="wrapper" style="width: 391px!important;">
                <header class="flexible no-bg">
                  <h5 class="inline-block width-100 text-center">
                    <i class="fa fa-phone"></i>
                    {{'front_contact_form.contact'| translate}}
                  </h5>
                </header>
                <div class="alert alert-danger" role="alert" *ngIf="errors.length">
                  <b> {{'front_contact_form.errors'| translate}} :</b>
                  <ul>
                    <li *ngFor="let error of errors">{{error}}</li>
                  </ul>
                  {{ errorMsg }}
                </div>
                <form  *ngIf="!done"  (ngSubmit)="onSubmit(contactForm.valid)"  #contactForm="ngForm">
                  <div class="table-wrapper">
                    <div class="width-100 table">
                      <div class="table-row flexible width-100 border-top" [ngClass]="{'has-danger': last_name.errors && (last_name.dirty ||last_name.touched || errors.length)}">
                        <div class="flexible width-100">
                          <div class="column flexible fixed-title text-left no-border-right"><label for="last_name" class="inline-block width-100">{{'front_contact_form.lastname'| translate}}</label></div>
                          <div class="column flexible title text-left width-100 rmp">
                            <input type="text" name="last_name" #last_name="ngModel" value="{{contact.last_name}}" required id="last_name" placeholder="{{'front_contact_form.enter_your_name'| translate}}" [(ngModel)]="contact.last_name"  class="width-100 height-100 text-left input-in-table">
                          </div>
                        </div>
                      </div>
                      <div class="table-row flexible width-100" [ngClass]="{'has-danger': first_name.errors && (first_name.dirty ||first_name.touched || errors.length)}">
                        <div class="flexible width-100">
                          <div class="column flexible fixed-title text-left no-border-right"><label for="first_name" class="inline-block width-100">{{'front_contact_form.firstname'| translate}}</label></div>
                          <div class="column flexible title text-left width-100 rmp">
                            <input type="text" name="first_name" id="first_name" required placeholder="{{'front_contact_form.enter_your_firstname'| translate}}"  #first_name="ngModel" [(ngModel)]="contact.first_name" value="" class="width-100 height-100 text-left input-in-table">
                          </div>
                        </div>
                      </div>
                      <div class="table-row flexible width-100" [ngClass]="{'has-danger': email.errors && (email.dirty ||email.touched || errors.length)}">
                        <div class="flexible width-100">
                          <div class="column flexible fixed-title text-left no-border-right"><label for="email" class="inline-block width-100">{{'front_contact_form.email'| translate}}</label></div>
                          <div class="column flexible title text-left no-border width-100 rmp">
                            <input type="email" name="email" id="email"  value="" required  #email="ngModel" placeholder="{{'front_contact_form.your_email'| translate}}" [(ngModel)]="contact.email" class="width-100 height-100 text-left input-in-table">
                          </div>
                        </div>
                      </div>

                      <div style="padding:10px;padding-top: 10px;" class="table-row width-100" [ngClass]="{'has-danger': message.errors && (message.dirty ||message.touched || errors.length)}">
                        <div class=" fixed-title text-left no-border-right " style="display: block"><label for="message" class="inline-block width-100">{{'front_contact_form.enter_your_message'| translate}}</label></div>
                        <div class="width-100">
                          <div class="title text-left width-100 rmp contain-textarea">
                            <textarea class="width-100 height-100 text-left input-in-table form-control"  required #message="ngModel" [(ngModel)]="contact.message" id="message" name="message" rows="10"></textarea>
                          <!--  <input type="text" >-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <span *ngIf="pendingRequest"  class="bold" style="display: block">{{'front_contact_form.processing'| translate}}</span>
                    <button type="submit"  class="btn btn-primary btn-lg pull-center" >{{'front_contact_form.send'| translate}}</button>
                  </div>
                </form>
                <div class="text-center" *ngIf="done">
                  <div class="inline-block">
                    <i class="fa fa-check check text-green"></i>
                    <h5 class="text-uppercase" >{{'front_contact_form.your_message_has_bee_sent'| translate}}</h5>
                    <button type="" style="margin-top: 20px" (click)="okk()" class="btn btn-primary  pull-center" >Ok</button>

                  </div>
                </div>


            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

